import { useState } from 'react'
import { Sidebar, Menu, MenuItem, sidebarClasses } from 'react-pro-sidebar'
import { Link, useLocation } from 'react-router-dom'
import { ReactComponent as AbLogo } from '../assets/icons/AbLogo.svg'
import { Box, Tooltip, useMediaQuery, useTheme } from '@mui/material'
import useCustomStyles from '../hooks/CustomStylesHook'
import { routes as appRoutes } from '../Routes'
import Colors from '../utils/colors.json'

const styles = () => ({
  sideNavHeading: {
    fontSize: '20px',
    fontWeight: 600,
    // color: theme.palette.primary.main,
    color: Colors.WHITE_BACKGROUND,
    lineHeight: '30px',
  },
  sideNavAb: {
    minWidth: '270px',
    borderRight: 'unset !important',
    [`.${sidebarClasses.container}`]: {
      borderRadius: '12px',
      // backgroundColor: theme.palette.primary.light,
      color: Colors.WHITE_BACKGROUND,
      background: Colors.SIDE_NAV_BG,
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },
  },
  sideNavAbMenu: {
    paddingLeft: 4,
    paddingRight: 4,
    fontSize: '14px',
  },
  isTabletOverride: {
    [`.${sidebarClasses.container}`]: {
      height: '100vh',
      borderRadius: 'unset',
      // backgroundColor: theme.palette.primary.light,
      color: Colors.WHITE_BACKGROUND,
      background: Colors.SIDE_NAV_BG,
      '&:hover': {
        backgroundColor: 'transparent !important',
      },
    },
  },

  // sideNavAbMenuItem: {
  //   '&:hover': {
  //     background: Colors.MENU_ITEM_BG,
  //     color: theme.palette.primary.main,
  //     '& .MuiSvgIcon-root': {
  //       color: theme.palette.primary.main,
  //     },
  //   },
  // },
  // selectedMenuItem: {
  //   color: theme.palette.primary.main,
  //   // background: `linear-gradient(to right, transparent 10px, ${Colors.MENU_ITEM_BG} 10px, ${Colors.MENU_ITEM_BG} calc(100% - 10px), transparent calc(100% - 10px))`,
  //   background: Colors.MENU_ITEM_BG,
  // },
})

const SideNav = () => {
  const location = useLocation()
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const isTabletOrBelow = useMediaQuery('(max-width: 768px)')
  const [openNav, setOpenNav] = useState(true)

  const toggleSideNav = () => {
    setOpenNav(!openNav)
  }

  return (
    <Box display={'flex'} pr={!isTabletOrBelow ? 3 : 0}>
      <Sidebar
        className={`${classes?.sideNavAb} ${
          isTabletOrBelow ? classes?.isTabletOverride : ''
        }`}
        collapsed={isTabletOrBelow ? false : openNav}
      >
        <Menu
          menuItemStyles={{
            button: {
              '&:hover': {
                backgroundColor: 'transparent',
              },
            },
          }}
        >
          <MenuItem
            icon={<AbLogo />}
            className={classes?.sideNavHeading}
            onClick={toggleSideNav}
          >
            Ayuvu Bharosa
          </MenuItem>
        </Menu>

        <Menu
          className={classes?.sideNavAbMenu}
          menuItemStyles={{
            button: ({ active }) => {
              if (active) {
                return {
                  borderRadius: '20px',
                  height: '40px',
                  marginBottom: 2,
                  background: Colors.MENU_ITEM_BG,
                  color: theme.palette.primary.main,
                  '&:hover': {
                    background: Colors.MENU_ITEM_BG,
                    color: theme.palette.primary.main,
                    '& .MuiSvgIcon-root': {
                      color: theme.palette.primary.main,
                    },
                  },
                }
              } else {
                return {
                  borderRadius: '20px',
                  height: '40px',
                  marginBottom: 2,
                  '&:hover': {
                    background: Colors.MENU_ITEM_BG,
                    color: theme.palette.primary.main,
                    '& .MuiSvgIcon-root': {
                      color: theme.palette.primary.main,
                    },
                  },
                }
              }
            },
          }}
        >
          {appRoutes?.slice(0, 9)?.map((route, index) => (
            <Tooltip title={route?.title} key={index} placement='right'>
              <MenuItem
                component={<Link to={route?.path} />}
                icon={<route.icon fontSize='medium' />}
                active={location?.pathname === route?.path ? true : false}
                // className={`${classes?.sideNavAbMenuItem} ${
                //   location?.pathname === route?.path
                //     ? classes?.selectedMenuItem
                //     : ''
                // }`}
              >
                {route?.title}
              </MenuItem>
            </Tooltip>
          ))}
        </Menu>
      </Sidebar>
    </Box>
  )
}

export default SideNav
